export const Admit = 'admit';
export const TurnBack = 'turnback';
